export default "__VITE_ASSET__f5be27f2__"